var Carrs;
(function($){

    Carrs = {

        $sliders: false,
        $cursors: false,

        init : function(){

            this.$sliders = $( '.slider-wrapper' );
            if( !this.$sliders.length ) return;

            for( var sls=0; sls<this.$sliders.length; sls++ ){
                Carrs.configure( this.$sliders.eq( sls ) );
            }

        },

        configure : function( $slider ){

            // Data
            var data = {
                _ : $slider.get(0),
                $ : $slider,
                $cursor: false
            };
            data.$cursor = Carrs.getCursor( data );

            // Events
            data.$.mousemove(function(e){

                var x = e.clientX;
                var y = e.clientY - Math.round( data.$.offset().top - Carrs.getScrollY() );

                data.$cursor.css({
                    left: x + 'px',
                    top: y + 'px',
                });

            });

            // Keeping data
            $slider.data( 'Carrs', data );

            // var $crsl = $( e.target ).parents( '.slider-wrapper' );

            // console.info( "$crsl" );
            // console.log( $crsl );
            // console.info( "e" );
            // console.log( e );
            // console.info( "e" );
            // console.log( e );
            
            /*
            this.$ = this.$ || $( this );
            var $c = Carrs.getCursor( this );
            $c.css({ left: x, top: y });
            */

        },

        getScrollY : function() {
            if( window.pageYOffset != undefined ){
                return pageYOffset;
            } 
            else {
                var 
                    r = d.documentElement,
                    b = d.body
                ;
                return r.scrollLeft || b.scrollLeft || 0;
            }        
        },

        getCursor : function( data ){
            if( !data.$cursor ){
                data.$cursor = $( '<span class="cursor" />' ).appendTo( data.$ );
            }
            return data.$cursor;
        }
    
    };
    $(function(){
        //Carrs.init();
    });

})(jQuery);